
import React, { Component, Fragment } from 'react';
import { Button, Col, Container, Input, InputGroup, InputGroupText, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { ArcaHttpClientPageDetails } from '../../../code/ArcaHttpClientPageDetails';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';

export class PhotoSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            photoList: null,
            dropdownOpen: false,
        };
    }

    async componentDidMount() {
        await ArcaHttpClientPageDetails.GetPhotoListAsync(
            (l => this.setState({ photoList: l })),
            (() => alert('404 not found')),
            (err => alert(err))
        )
    }

    toggleDropDown() {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }

    render() {
        let { dropdownOpen, photoList } = this.state
        let { mandatory, label, value } = this.props

        return (
            <Fragment>
                <InputGroup>
                    {/*<InputGroupAddon addonType='prepend'>*/}
                        <InputGroupText style={{ width: '160px' }}>
                            {label}
                            {mandatory
                                ? <span style={{ color: 'red', fontSize: '15px' }}>*</span>
                                : null}
                        </InputGroupText>
                    {/*</InputGroupAddon>*/}

                    <Input
                        fieldname='label'
                        value={value}
                        readOnly={true}>
                    </Input>
                    <img
                        src={`${ArcaHttpSystem.PhotoFolder}Photos/${value}TN.jpg`}
                        alt={value}
                    />

                    {/*<InputGroupAddon addonType="append" >*/}
                        <Button onClick={this.toggleDropDown.bind(this)}>
                            Select
                        </Button>
                    {/*</InputGroupAddon>*/}
                </InputGroup>

                {dropdownOpen
                    ? <Modal isOpen={true} toggle={this.toggleDropDown.bind(this)} className="">
                        <ModalHeader
                            toggle={this.toggleDropDown.bind(this)}>Photo selection
                                </ModalHeader>

                        <ModalBody>
                            <Container>
                                <Row>
                                    <Col>
                                        <span onClick={this.handleUserInput.bind(this, null)}>
                                            No photo
                                        </span>
                                    </Col>

                                    {photoList.map((item, key) =>
                                        <Col key={key} onClick={this.handleUserInput.bind(this, item)}>
                                            <img
                                                src={`${ArcaHttpSystem.PhotoFolder}Photos/${item}TN.jpg`}
                                                alt={item}
                                            />
                                            {item}
                                        </Col>
                                    )}
                                </Row>
                            </Container>
                        </ModalBody>
                    </Modal>
                    : null
                }


            </Fragment>
        );
    }

    handleUserInput(item) {
        this.props.onUpdate(item, true, this.props.fieldname);

        this.setState({ dropdownOpen: false })
    }
}